import { API_END_POINT } from "../../Api/EndPoints";
import API from "../../Api/Api";

export const getCategories = (signal) => async (dispatch) => {
  dispatch({ type: "FETCH_CATEGORIES_LOADING" });
  try {
    const { data } = await API.get(
      `${API_END_POINT}api/categories?populate=gammes&sort[0]=id`,
      { signal },
    );
    const payload = data?.data?.map((item) => ({
      name: item?.attributes?.name,
      code: item?.id,
      ranges: item?.attributes?.gammes?.data?.map((rangeItem) => ({
        name: rangeItem?.attributes?.name,
        code: rangeItem?.id,
      })),
    }));

    dispatch({ type: "FETCH_CATEGORIES_SUCCESS", payload });
  } catch (error) {
    if (error.name === "CanceledError" || error.code === "ERR_CANCELED") return;
    dispatch({ type: "FETCH_CATEGORIES_ERROR" });
  }
};
